import React, { useState } from "react";
import SidebarMenu from "./menu";
import { RoutePaths } from "../../routes/route";

interface SidebarMenuItem {
  name: string;
  icon: string;
  path: string;
  isNavigationHeader?: boolean;
  children?: SidebarMenuItem[]; // Optional children
}

const sidebarMenu: SidebarMenuItem[] = [
  {
    name: "Overview",
    isNavigationHeader: true,
    icon: "icon-dashboard",
    path: "/dashboard",
  },
  {
    name: "Member RFM Chart",
    icon: "icon-dashboard",
    path: RoutePaths.HOME,
  },
  {
    name: "Member RFM Segment Setting",
    isNavigationHeader: true,
    icon: "icon-dashboard",
    path: "/dashboard",
  },
  // {
  //   name: "Segment Tier Settings",
  //   icon: "icon-segment",
  //   path: RoutePaths.SEGMENTTIERSETTING,
  // },
  {
    name: "Member RFM Segment",
    icon: "icon-segment",
    path: RoutePaths.COMBINATIONRFM,
  },
  {
    name: "RFM Profile Settings",
    icon: "icon-rfm-settings",
    path: RoutePaths.RFMPROFILE,
  },
  {
    name: "Target Marketing",
    isNavigationHeader: true,
    icon: "icon-dashboard",
    path: RoutePaths.TARGET_MARKETING_HOME,
  },
  {
    name: "Target Marketing Home",
    icon: "icon-dashboard",
    path: RoutePaths.TARGET_MARKETING_HOME,
  },
  // {
  //   name: "Target Marketing All",
  //   icon: "icon-dashboard",
  //   path: RoutePaths.TARGET_MARKETING_ALL,
  // },
  // {
  //   name: "Create Campaign",
  //   icon: "icon-dashboard",
  //   path: RoutePaths.CREATE_CAMPAIGN,
  // },
  // {
  //   name: "Message Templates",
  //   icon: "icon-dashboard",
  //   path: RoutePaths.MESSAGE_TEMPLATES,
  // },
  // {
  //   name: "Create Message Templates",
  //   icon: "icon-dashboard",
  //   path: RoutePaths.CREATE_MESSAGE_TEMPLATES,
  // },
];

const Sidebar: React.FC = () => {
  const [openMenus, setOpenMenus] = useState<{ [key: string]: boolean }>({});

  const toggleMenu = (menuName: string) => {
    setOpenMenus((prev) => ({
      ...prev,
      [menuName]: !prev[menuName],
    }));
  };

  return (
    <div className="sidebar sidebar-main">
      <div className="sidebar-content">
        <div className="sidebar-category sidebar-category-visible">
          <div className="category-content no-padding">
            <ul className="navigation navigation-main navigation-accordion">
              {sidebarMenu.map((m, index) =>
                m.isNavigationHeader ? (
                  <li key={index} className="navigation-header">
                    <span>{m.name}</span>
                  </li>
                ) : m.children && m.children.length > 0 ? (
                  <li key={index} className={openMenus[m.name] ? "active" : ""}>
                    <a href="#" onClick={() => toggleMenu(m.name)}>
                      <i className={m.icon}></i> <span>{m.name}</span>
                    </a>
                    <ul
                      style={{ display: openMenus[m.name] ? "block" : "none" }}
                    >
                      {m.children.map((child) => (
                        <li key={child.name}>
                          <a href={child.path}>{child.name}</a>
                        </li>
                      ))}
                    </ul>
                  </li>
                ) : (
                  <SidebarMenu
                    key={index}
                    name={m.name}
                    icon={m.icon}
                    path={m.path}
                  />
                )
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
